// This file is AUTOGENERATED, do not edit it manually!!!

export const activityList = {
    Indicator_Counter_Tooltip: 'Number of activities at risk',
};
